
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import { NextSeo } from "next-seo";
import Layout from "@/components/core/Layout";
import request from "@/utils/request";
import Content from "@/components/content";

const TermsOfUse = ({ content, title }) => (
  <Layout>
    <NextSeo title={title} noindex />
    <Content content={content} />
  </Layout>
);

 async function _getStaticProps({ locale }) {
  const { data: content } = await request.get("/content", {
    params: { urlPath: "nutzungsbedingungen", language: "de" },
    headers: { "Accept-Language": locale },
  });

  return {
    props: {
      title: content.name,
      content: content.content,
    },
  };
}

export default TermsOfUse;


    export async function getStaticProps(ctx) {
        let res = _getStaticProps(ctx)
        if(typeof res.then === 'function') res = await res
        return {
          
          ...res,
          props: {
            ...(res.props || {}),
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/terms-of-use',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  